<template>
  <div style="position: relative; height: 300px">
    <div class="dinwdw">
      <div class="name_boxr">订单状态：</div>
      <div>
        <div class="item">
          <el-select
            v-model="state"
            placeholder="状态"
            style="width: 350px"
            filterable
            :clearable="true"
          >
            <el-option label="已支付" :value="1" />
            <el-option label="未支付" :value="0" />
          </el-select>
        </div>
      </div>
    </div>
    <div class="item">
      <div class="name_boxr">选择时间：</div>
      <div style="flex: 1">
        <div class="block">
          <el-date-picker
            v-model="date"
            type="daterange"
            align="right"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </div>
      </div>
    </div>
    <div class="butpostion">
      <el-button
        :loading="submitLoading"
        type="primary"
        plain
        @click="submit"
      >导出</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      submitLoading: false,
      date1: this.getNowFormatDate(window.Date.now()),
      date: [],
      account_id: '',
      datas: {},
      state: 1
    }
  },
  methods: {
    rightclicktwoGroup(item, indexr) {
      console.log(item, indexr)
      this.admincode = {}
      this.account_id = ''
    },
    submit() {
      console.log('this.date1:', this.date, this.state)
      if (this.date === null || this.date.length === 0) {
        return this.$message('请选择时间')
      }
      if (this.state === '' || this.state === null) {
        return this.$message('请选择状态')
      }
      const a = new Date(this.date[0])
      const b = new Date(this.date[1])

      const maxDate = new Date(a)
      maxDate.setDate(a.getDate() + 2)

      if (b >= a && b <= maxDate) {
        console.log('b 在范围内，可以选择')
      } else {
        return this.$message('时间超出了3天范围，不符合要求')
      }
      this.submitLoading = true
      const obj = {
        start_date: this.date[0],
        end_date: this.date[1],
        state: this.state
      }
      this.$emit('determine', obj)
      this.submitLoading = false
      this.state = 1
      this.date = []
    },

    send(row) {
      console.log('row:', row)
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }
  }
}
</script>

<style scoped lang="less">
.item {
  display: flex;
  align-items: center;
  margin-right: 20px;

  .item_title {
    margin-right: 10px;
    display: inline-block;
  }
  .item_input {
    width: 200px;
  }
}
.butpostion {
  position: absolute;
  top: 180px;
  right: 200px;
}
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  text-align: right;
  flex-shrink: 0;
}
</style>
